import { PRIMARY_PAYMENT_DEFAULT } from 'src/global/theme/colors';
import { makeStyles } from 'tss-react/mui';

export const styles = makeStyles()(() => {
  return {
    numberItem: {
      cursor: 'pointer',
      borderRadius: '6px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: "4px 16px",
      margin: "8px",
    },
    active: {
      backgroundColor: PRIMARY_PAYMENT_DEFAULT,
      pointerEvents:'none'
    }
  };
});
